// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/firstparty/v4/search_subscription_payments.proto

/* oxlint-disable */
import { ApiPaginationInput, ApiPaginationMeta } from "../../../../common/pagination";
import { ApiPayment, ApiPaymentStatus, apiPaymentStatusFromJSON, apiPaymentStatusToJSON } from "./subscription";

/** Message for search subscription payments filter parameters */
export interface ApiSearchSubscriptionPaymentsRequestFilters {
  /** Filter by payment status - array of statuses. The absence of value, will return everything. */
  readonly status: readonly ApiPaymentStatus[];
}

/** Request message for SearchSubscriptionPayments */
export interface ApiSearchSubscriptionPaymentsRequest {
  /** Payment link ID (UUID format) */
  readonly paymentLinkId: string;
  /** Subscription ID (UUID format) */
  readonly subscriptionId: string;
  /** Filters parameters (optional) */
  readonly filters?:
    | ApiSearchSubscriptionPaymentsRequestFilters
    | null
    | undefined;
  /** Pagination parameters (optional) */
  readonly paginationInput?:
    | ApiPaginationInput
    | null
    | undefined;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  readonly sortField: readonly ApiSearchSubscriptionPaymentsRequestSortField[];
}

/** Enum for sort fields for search subscription payments request */
export const ApiSearchSubscriptionPaymentsRequestSortField = {
  /** SORT_FIELD_UNSPECIFIED - Default unspecified value for unknown or unrecognized sort field */
  SORT_FIELD_UNSPECIFIED: "SORT_FIELD_UNSPECIFIED",
  /** SORT_FIELD_CREATED_AT_ASC - Sort by created at ASC */
  SORT_FIELD_CREATED_AT_ASC: "SORT_FIELD_CREATED_AT_ASC",
  /** SORT_FIELD_CREATED_AT_DESC - Sort by created at DESC */
  SORT_FIELD_CREATED_AT_DESC: "SORT_FIELD_CREATED_AT_DESC",
} as const;

export type ApiSearchSubscriptionPaymentsRequestSortField =
  typeof ApiSearchSubscriptionPaymentsRequestSortField[keyof typeof ApiSearchSubscriptionPaymentsRequestSortField];

export namespace ApiSearchSubscriptionPaymentsRequestSortField {
  export type SORT_FIELD_UNSPECIFIED = typeof ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED;
  export type SORT_FIELD_CREATED_AT_ASC =
    typeof ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_CREATED_AT_ASC;
  export type SORT_FIELD_CREATED_AT_DESC =
    typeof ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_CREATED_AT_DESC;
}

export function apiSearchSubscriptionPaymentsRequestSortFieldFromJSON(
  object: any,
): ApiSearchSubscriptionPaymentsRequestSortField {
  switch (object) {
    case 0:
    case "SORT_FIELD_UNSPECIFIED":
      return ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED;
    case 1:
    case "SORT_FIELD_CREATED_AT_ASC":
      return ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_CREATED_AT_ASC;
    case 2:
    case "SORT_FIELD_CREATED_AT_DESC":
      return ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_CREATED_AT_DESC;
    default:
      return ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED;
  }
}

export function apiSearchSubscriptionPaymentsRequestSortFieldToJSON(
  object: ApiSearchSubscriptionPaymentsRequestSortField,
): string {
  switch (object) {
    case ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_UNSPECIFIED:
      return "SORT_FIELD_UNSPECIFIED";
    case ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_CREATED_AT_ASC:
      return "SORT_FIELD_CREATED_AT_ASC";
    case ApiSearchSubscriptionPaymentsRequestSortField.SORT_FIELD_CREATED_AT_DESC:
      return "SORT_FIELD_CREATED_AT_DESC";
    default:
      return "SORT_FIELD_UNSPECIFIED";
  }
}

/** Response message for searching subscription payments */
export interface ApiSearchSubscriptionPaymentsResponse {
  /** Array of payments related to the subscription */
  readonly payments: readonly ApiPayment[];
  /** Pagination metadata */
  readonly pagination: ApiPaginationMeta | null;
}

export const ApiSearchSubscriptionPaymentsRequestFilters: MessageFns<ApiSearchSubscriptionPaymentsRequestFilters> = {
  fromJSON(object: any): ApiSearchSubscriptionPaymentsRequestFilters {
    return {
      status: globalThis.Array.isArray(object?.status)
        ? object.status.map((e: any) => apiPaymentStatusFromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiSearchSubscriptionPaymentsRequestFilters): unknown {
    const obj: any = {};
    if (message.status?.length) {
      obj.status = message.status.map((e) => apiPaymentStatusToJSON(e));
    }
    return obj;
  },
};

export const ApiSearchSubscriptionPaymentsRequest: MessageFns<ApiSearchSubscriptionPaymentsRequest> = {
  fromJSON(object: any): ApiSearchSubscriptionPaymentsRequest {
    return {
      paymentLinkId: isSet(object.payment_link_id) ? globalThis.String(object.payment_link_id) : "",
      subscriptionId: isSet(object.subscription_id) ? globalThis.String(object.subscription_id) : "",
      filters: isSet(object.filters) ? ApiSearchSubscriptionPaymentsRequestFilters.fromJSON(object.filters) : null,
      paginationInput: isSet(object.pagination_input) ? ApiPaginationInput.fromJSON(object.pagination_input) : null,
      sortField: globalThis.Array.isArray(object?.sort_field)
        ? object.sort_field.map((e: any) => apiSearchSubscriptionPaymentsRequestSortFieldFromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiSearchSubscriptionPaymentsRequest): unknown {
    const obj: any = {};
    if (message.paymentLinkId !== undefined && message.paymentLinkId !== null) {
      obj.payment_link_id = message.paymentLinkId;
    }
    if (message.subscriptionId !== undefined && message.subscriptionId !== null) {
      obj.subscription_id = message.subscriptionId;
    }
    if (message.filters !== undefined && message.filters !== null) {
      obj.filters = ApiSearchSubscriptionPaymentsRequestFilters.toJSON(message.filters);
    }
    if (message.paginationInput !== undefined && message.paginationInput !== null) {
      obj.pagination_input = ApiPaginationInput.toJSON(message.paginationInput);
    }
    if (message.sortField?.length) {
      obj.sort_field = message.sortField.map((e) => apiSearchSubscriptionPaymentsRequestSortFieldToJSON(e));
    }
    return obj;
  },
};

export const ApiSearchSubscriptionPaymentsResponse: MessageFns<ApiSearchSubscriptionPaymentsResponse> = {
  fromJSON(object: any): ApiSearchSubscriptionPaymentsResponse {
    return {
      payments: globalThis.Array.isArray(object?.payments)
        ? object.payments.map((e: any) => ApiPayment.fromJSON(e))
        : [],
      pagination: isSet(object.pagination) ? ApiPaginationMeta.fromJSON(object.pagination) : null,
    };
  },

  toJSON(message: ApiSearchSubscriptionPaymentsResponse): unknown {
    const obj: any = {};
    if (message.payments?.length) {
      obj.payments = message.payments.map((e) => ApiPayment.toJSON(e));
    }
    if (message.pagination !== undefined && message.pagination !== null) {
      obj.pagination = ApiPaginationMeta.toJSON(message.pagination);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
